export const SET_SCREEN_SIZE = 'scratch-gui/screen-size/SET_SCREEN_SIZE';
export const RESTORE_UPDATE = 'scratch-gui/screen-size/RESTORE_UPDATE';

// Action Creators
export const setScreenSize = (size) => ({
    type: SET_SCREEN_SIZE,
    payload: size,
});

export const restoreScreenSize = (state) => ({
    type: RESTORE_UPDATE,
    state: {
        screenSize: state.screenSize,
    },
});
